import { z } from "zod";
/** Firestore Timestamp on the server, Date in the dashboard. Validators accept both. */
export const timestampSchema = z.union([
    z.date(),
    z.object({ seconds: z.number(), nanoseconds: z.number() }),
    z.custom((v) => typeof v === "object" && v !== null && "toDate" in v),
]);
export const localeSchema = z.enum(["en-GB", "tr-TR"]);
/** E.164 phone number, e.g. +447700900123. */
export const e164Schema = z.string().regex(/^\+[1-9]\d{6,14}$/, "E.164 phone number required");
export const emailSchema = z.email().max(254);
/** Stable identifiers used inside forms and documents. */
export const idSchema = z
    .string()
    .min(1)
    .max(64)
    .regex(/^[A-Za-z0-9_-]+$/);
/** Clinic slug used in the badge URL and the record link. */
export const slugSchema = z
    .string()
    .min(2)
    .max(48)
    .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/);
/** Short lead reference, unambiguous (no 0/O/1/I), unique per clinic. */
export const LEAD_REF_ALPHABET = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ";
export const leadRefSchema = z.string().regex(/^[23456789ABCDEFGHJKLMNPQRSTUVWXYZ]{4,6}$/);
export const hexColourSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/);
export const urlSchema = z.url().max(2048);
/** Wall-clock time "HH:MM" (opening hours, availability). */
export const hhmmSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "HH:MM");
//# sourceMappingURL=common.js.map